import type { CardDefinition, CaseDefinition } from "../../domain/types/index.js";
import { listRewardOrganizations } from "../../content/lookups.js";
import { CardView } from "../../components/CardView.js";
import { clearRewardCopy, clearRewardTitle } from "./clearRewardCopy.js";
import { OrgPoolList } from "./OrgPoolList.js";

type Props = {
  spec: CaseDefinition;
  rewardCards: CardDefinition[];
  isOpen: boolean;
  stageId?: string;
  onToggle: () => void;
};

export function NodeRewardSection({ spec, rewardCards, isOpen, stageId, onToggle }: Props) {
  return (
    <section className="map-sheet-reward" aria-label="クリア報酬">
      <button
        type="button"
        className="map-sheet-reward-toggle"
        aria-expanded={isOpen}
        aria-controls="reward-pool-details"
        onClick={onToggle}
      >
        <span>{clearRewardTitle(spec)}</span>
        <span aria-hidden="true">{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && (
        <div id="reward-pool-details">
          <p>{clearRewardCopy(spec)}</p>
          {spec.grantsOrganization && (
            <OrgPoolList organizations={listRewardOrganizations(stageId)} />
          )}
          <h3>報酬プール（カード一覧）</h3>
          <div className="map-sheet-reward-cards" aria-label="報酬プールのカード一覧">
            {rewardCards.map((card) => (
              <CardView
                key={card.id}
                card={{ instanceId: `reward-preview-${card.id}`, cardId: card.id }}
                definition={card}
                disabled
                className="map-sheet-reward-card"
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
